import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {  LoginComponent } from './login/login.component';
import {  DashboardComponent } from './dashboard/dashboard.component';
import {  MatchDetailComponent } from './match-detail/match-detail.component';
import { HomeComponent } from './home/home.component';
import { InplayComponent } from './inplay/inplay.component';
import { StatementComponent } from './statement/statement.component';
import { ProfitLossComponent } from './profit-loss/profit-loss.component';
import { MyBetComponent } from './my-bet/my-bet.component';
import { ReportsComponent} from './reports/reports.component';
import { ReportMarketComponent} from './report-market/report-market.component'
import { AuthCheckGuard } from './services/auth-check.guard';
import { ExchangeDetailComponent } from './exchange-detail/exchange-detail.component';
import {  CasinoComponent } from './casino/casino.component';
import { RentalLoginComponent } from './rental-login/rental-login.component';
import { MaxLoginComponent  } from './max-login/max-login.component';
import { SupernovaComponent } from './supernova/supernova.component';
import { EventplComponent } from './eventpl/eventpl.component';
import { MultiMarketComponent } from './multi-market/multi-market.component';
import { PlMatchWiseComponent } from './pl-match-wise/pl-match-wise.component';
import { PlMarketwiseComponent } from './pl-marketwise/pl-marketwise.component';
import { PlUserBetComponent } from './pl-user-bet/pl-user-bet.component';
import { InfoComponent } from './info/info.component';
import { HistoryComponent } from './history/history.component';
import { ActivitylogComponent } from './activitylog/activitylog.component';
import { RollingComissionComponent } from './rolling-comission/rolling-comission.component';
import { SportsMainComponent } from './sports-main/sports-main.component';
import { MyAccountComponent } from './my-account/my-account.component';
import { BetHistoryComponent } from './bet-history/bet-history.component';
import { PlUserBetSnComponent } from './pl-user-bet-sn/pl-user-bet-sn.component';
import { NoActivePageComponent } from './no-active-page/no-active-page.component';
import { CasinoDetailComponent } from './casino-detail/casino-detail.component';
import { BaccaratComponent } from './baccarat/baccarat.component';
import { Cards32Component } from './cards32/cards32.component';
import { TeenpattiComponent } from './teenpatti/teenpatti.component';
import { PokerComponent } from './poker/poker.component';
import { Lucky7Component } from './lucky7/lucky7.component';
import { QtechComponent } from './qtech/qtech.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { EditStackComponent } from './edit-stack/edit-stack.component';
import { RulesComponent } from './rules/rules.component';
import {UnsettleBetComponent } from './unsettle-bet/unsettle-bet.component';
import { DepositComponent } from './deposit/deposit.component';
import { WithdrawComponent } from './withdraw/withdraw.component';
import { WidthdrawDetailsComponent } from './widthdraw-details/widthdraw-details.component';
import { RegisterComponent } from './register/register.component';
import { TransactionHistoryComponent } from './transaction-history/transaction-history.component';

import { AboutUsComponent } from './about-us/about-us.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { TermConditionComponent } from './term-condition/term-condition.component';


const routes: Routes = [
  {path: '', redirectTo: 'login', pathMatch: 'full'},
  {path: 'login', component: LoginComponent},
  // {path: 'login', component: MaxLoginComponent},
  // {path: 'login', component: RentalLoginComponent},
  {path: 'dashboard', component: DashboardComponent , canActivate: [AuthCheckGuard]},
  {path: 'about-us', component: AboutUsComponent , canActivate: [AuthCheckGuard]},
  {path: 'privacy-policy', component: PrivacyPolicyComponent , canActivate: [AuthCheckGuard]},
  {path: 'contact-us', component: ContactUsComponent , canActivate: [AuthCheckGuard]},
  {path: 'term-conditions', component: TermConditionComponent , canActivate: [AuthCheckGuard]},
  {path: 'changePwd', component: ChangePasswordComponent , canActivate: [AuthCheckGuard]},
  {path: 'editStack', component: EditStackComponent , canActivate: [AuthCheckGuard]},
  {path: 'betHistory', component: BetHistoryComponent , canActivate: [AuthCheckGuard]},
  {path: 'dashboard/:sportName', component: DashboardComponent , canActivate: [AuthCheckGuard]},
  {path: 'match-detail', component: MatchDetailComponent , canActivate: [AuthCheckGuard]},
  {path: 'match-detail/:match_id', component: MatchDetailComponent , canActivate: [AuthCheckGuard]},
  { path: 'password', component: ChangePasswordComponent ,canActivate : [AuthCheckGuard]},
  // {path: 'home/:sportId/:seriesId', component: HomeComponent , canActivate: [AuthCheckGuard]},
  
  {path: 'home', component: HomeComponent , canActivate: [AuthCheckGuard]},
  {path: 'inplay', component: InplayComponent , canActivate: [AuthCheckGuard]},
  {path: 'inplay/:data', component: InplayComponent , canActivate: [AuthCheckGuard]},
  {path: 'statement', component: StatementComponent , canActivate: [AuthCheckGuard]},
  {path: 'profit-loss', component: ProfitLossComponent , canActivate: [AuthCheckGuard]},
  {path: 'casino-detail/:gameCode/:providerCode', component: CasinoDetailComponent , canActivate: [AuthCheckGuard]},
  {path: 'casino-detail/:id', component: CasinoDetailComponent , canActivate: [AuthCheckGuard]},
  {path: 'my-bet/:matchId/:marketId/:type', component: MyBetComponent , canActivate: [AuthCheckGuard]},
  {path:'reports',component:ReportsComponent , canActivate: [AuthCheckGuard]},
  {path:'reports/:activeTab',component:ReportsComponent , canActivate: [AuthCheckGuard]},
  {path:'myMarket',component:ReportMarketComponent , canActivate: [AuthCheckGuard]},
  {path:'multiMarket',component:MultiMarketComponent , canActivate: [AuthCheckGuard]},
  {path:'exchDetail',component:ExchangeDetailComponent , canActivate: [AuthCheckGuard]},
  { path: 'casino', component: CasinoComponent, canActivate: [AuthCheckGuard] },
  { path: 'snova/:id/:name/:code',component:SupernovaComponent, canActivate: [AuthCheckGuard] },
  { path: 'eventpl', component: EventplComponent, canActivate: [AuthCheckGuard] },
  { path: 'info', component: InfoComponent, canActivate: [AuthCheckGuard] },
  { path: 'history', component: HistoryComponent, canActivate: [AuthCheckGuard] },
  { path: 'sportsMain', component: SportsMainComponent, canActivate: [AuthCheckGuard] },
  { path: 'activity', component: ActivitylogComponent, canActivate: [AuthCheckGuard] },
  { path: 'myAccount', component: MyAccountComponent, canActivate: [AuthCheckGuard] },
  { path: 'na/:sportName', component: NoActivePageComponent, canActivate: [AuthCheckGuard] },
  { path: 'rollComission', component: RollingComissionComponent, canActivate: [AuthCheckGuard] },
  { path: 'rules', component: RulesComponent, canActivate: [AuthCheckGuard] },
  { path: 'plMatchwise/:sportId/:sportName/:fromDate/:toDate/:typeId', component: PlMatchWiseComponent, canActivate: [AuthCheckGuard] },
  { path: 'plMarketwise/:matchId/:matchName/:typeId/:sportId', component: PlMarketwiseComponent, canActivate: [AuthCheckGuard] },
  { path: 'plUserBet/:matchId/:marketId/:type', component: PlUserBetComponent, canActivate: [AuthCheckGuard] },
  { path: 'plSnUserBet/:marketId/:sportName/:matchName/:marketName', component: PlUserBetSnComponent, canActivate: [AuthCheckGuard] },
  { path: 'world-casino/:gameProvide', component: BaccaratComponent, canActivate: [AuthCheckGuard] },
  { path: '32c', component: Cards32Component, canActivate: [AuthCheckGuard] },
  { path: '3pt', component: TeenpattiComponent, canActivate: [AuthCheckGuard] },
  { path: 'poker', component: PokerComponent, canActivate: [AuthCheckGuard] },
  { path: 'l7', component: Lucky7Component, canActivate: [AuthCheckGuard] },
  {path: 'qtech', component: QtechComponent , canActivate: [AuthCheckGuard] },
  {path: 'casino', component: CasinoComponent },
  {path: 'unsetteledbet', component: UnsettleBetComponent , canActivate: [AuthCheckGuard] },
  {path: 'deposit', component: DepositComponent , canActivate: [AuthCheckGuard] },
  {path: 'withdraw', component: WithdrawComponent , canActivate: [AuthCheckGuard] },
  {path: 'withdraw-details', component: WidthdrawDetailsComponent , canActivate: [AuthCheckGuard] },
  {path: 'register', component: RegisterComponent },
  {path: 'register/:referCode', component: RegisterComponent },
  {path: 'transaction-history', component: TransactionHistoryComponent }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabled',
    relativeLinkResolution: 'legacy'
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
